// extracted by mini-css-extract-plugin
module.exports = {"heading":"App_heading__2nYdz","container":"App_container__1MQN3"};